<span class='star-rating'>
    <ng-container *ngIf='!forDisplay'>
      <i (click)='mark($index)' *ngFor='let n of range; let $index = index;' [ngClass]='isMarked($index)'
         class='fa to-rate'></i>
    </ng-container>
    <ng-container *ngIf='forDisplay'>
      <i *ngFor='let n of range; let $index = index;' [ngClass]='isMarked($index)' class="to-display"></i>
    </ng-container>
</span>
